import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { Check, Download, ShieldCheck, Zap } from 'lucide-react';
const MASTER_SYSTEM_CHECKOUT = 'https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026';
export function MasterFinalCTA() {
  const goToCheckout = () => {
    window.open(MASTER_SYSTEM_CHECKOUT, '_blank', 'noopener,noreferrer');
  };
  return <section className="bg-brand-green px-5 py-20 text-white sm:px-6 md:py-28" data-id="element-416" data-mp="1fxsgbldi1vdc">
      <div className="mx-auto max-w-3xl text-center" data-id="element-417" data-mp="1az7i1rht5lrj">
        <FadeIn data-id="element-418" data-mp="1b1tzqjyexhnh">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-419" data-mp="1690uluz187av">
            Amazon Master System™
          </p>
          <h2 className="font-serif text-4xl font-bold leading-tight tracking-tight sm:text-5xl" data-id="element-420" data-mp="118wck0ih74ij">
            Tu negocio en Amazon puede comenzar hoy
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-421" data-mp="1tylfwkinrgnb">
            Obtén acceso inmediato al sistema completo, aprende paso a paso y
            empieza con una metodología organizada diseñada para ayudarte a
            evitar errores comunes desde el primer día.
          </p>

          <ul className="mx-auto mt-8 grid max-w-2xl grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-422" data-mp="3ai24lh2jj3vu">
            {['Acceso inmediato', 'Pago único', 'Compatible con todos los dispositivos', 'Actualizaciones incluidas'].map(seal => <li key={seal} className="flex items-center gap-2 rounded-xl border border-white/15 bg-white/5 px-3 py-3 text-left text-xs font-semibold leading-snug text-white/85" data-id="element-423" data-mp="35ifqz6isvlmi">
                <Check className="h-3.5 w-3.5 shrink-0 text-brand-gold" strokeWidth={3} data-id="element-424" data-mp="2wiamb44zr1c1" />
                {seal}
              </li>)}
          </ul>
        </FadeIn>

        <FadeIn delay={0.12} data-id="element-425" data-mp="uo1qhaplf511">
          <div className="mx-auto mt-10 max-w-2xl" data-id="element-426" data-mp="sbzalrp2ee43">
            <Button onClick={goToCheckout} aria-label="Comenzar ahora" className="w-full" data-id="element-427" data-mp="scsmt86slvtm">
              COMENZAR AHORA
            </Button>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-xs font-medium text-white/70 sm:gap-x-6" data-id="element-428" data-mp="jb1hi4g5zr0a">
              <span className="flex items-center gap-1.5" data-id="element-429" data-mp="1bz73euiyfm1p">
                <Zap className="h-3.5 w-3.5 text-brand-gold" data-id="element-430" data-mp="1bynhl2q6odie" />
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-431" data-mp="172q20ymqvb6o">
                <ShieldCheck className="h-3.5 w-3.5 text-brand-gold" data-id="element-432" data-mp="128cefiebq8ck" />
                Pago único
              </span>
              <span className="flex items-center gap-1.5" data-id="element-433" data-mp="xaak21bg6mls">
                <Download className="h-3.5 w-3.5 text-brand-gold" data-id="element-434" data-mp="1uq7y36d1kvfg" />
                Descarga digital
              </span>
              <span className="flex items-center gap-1.5" data-id="element-435" data-mp="1pyg7ivtvyppb">
                <Zap className="h-3.5 w-3.5 text-brand-gold" data-id="element-436" data-mp="1xamgvbhca19u" />
                Acceso de por vida
              </span>
              <span className="flex items-center gap-1.5" data-id="element-437" data-mp="228nzjvauryks">
                <ShieldCheck className="h-3.5 w-3.5 text-brand-gold" data-id="element-438" data-mp="22bag2kfq1of5" />
                Compra 100 % segura
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}